"use client";
import React from "react";
import Heading from "../common/ui/Heading";
import { AWARDS_LIST } from "../../utils/other-component";

const AwardsSection = () => {
  return (
    <div className="max-w-[1140px] mx-auto px-4 sm:px-6 lg:px-8 py-[140px] max-xl:py-[120px] max-lg:py-24 max-md:py-20 max-sm:py-10">
      <Heading
        children="Honouring the Journey of Deepak Ji"
        className="pb-8 sm:pb-[50px] max-sm:text-center"
      />

      <div className="overflow-x-auto border-x border-[#00000033] max-md:border-y rounded-lg shadow-sm">
        <table className="min-w-[1000px] divide-y divide-gray-200 table-fixed">
          <thead className="bg-[#2920D2] text-white">
            <tr>
              <th className="text-left text-[22px] font-semibold px-4 py-3 w-[25%]">
                Award Title
              </th>
              <th className="text-left text-[22px] font-semibold px-4 py-3 w-[20%]">
                Location
              </th>
              <th className="text-left text-[22px] font-semibold px-4 py-3 w-[25%]">
                Organizer
              </th>
              <th className="text-left text-[22px] font-semibold px-4 py-3 w-[30%]">
                Description
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {AWARDS_LIST.map((award, index) => (
              <tr key={index}>
                <td className="px-4 py-4 text-[#010101] text-base sm:text-lg md:text-xl font-medium border">
                  {award.title}
                </td>
                <td className="px-4 py-4 text-gray-600 text-base sm:text-lg md:text-xl border">
                  {award.location}
                </td>
                <td className="px-4 py-4 text-[#5E5C5C] text-base sm:text-lg md:text-xl border ">
                  {award.organizer}
                </td>
                <td className="px-4 py-4 text-[#5E5C5C] text-base sm:text-lg md:text-xl border min-w-[400px]">
                  {award.description}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AwardsSection;
